import { render, staticRenderFns } from "./product-category-select.vue?vue&type=template&id=67536a8e&scoped=true&"
import script from "./product-category-select.vue?vue&type=script&lang=js&"
export * from "./product-category-select.vue?vue&type=script&lang=js&"
import style0 from "./product-category-select.vue?vue&type=style&index=0&id=67536a8e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67536a8e",
  null
  
)

export default component.exports